import { Injectable } from '@angular/core';
import { MSRemoteLoggerCategory, MSRemoteLoggerSeverity } from 'src/app/adapters/remote-logger/utils/remote-logger.utils';
import { RemoteLoggerUseCase } from '../../remote-logger/remote-logger.use-case';
import { MSFeatureFlags } from '../feature-flags';

@Injectable({
  providedIn: 'root'
})
export class DebugLoggingCapsule {

  constructor(
    private readonly remoteLogger: RemoteLoggerUseCase
  ) {}

  logIfAble(message: string): void {
    const loggingEnabled = MSFeatureFlags.get().enableVerboseLogging

    if (loggingEnabled) {
      this.remoteLogger.log(message, MSRemoteLoggerCategory.INIT, MSRemoteLoggerSeverity.INFO);
    }
  }
}
